import React, { useEffect, useState } from 'react'
import {
  DiscoverLegalPerspective,
  FeaturedArticle,
  DiscoverLawFilterSection,
  DiscoverPodcast,
} from './components/'
import './index.scss'
import { Button } from 'cwp-components/forms/Buttons'
import { DiscoverMore } from './components/discover-more-section'
import { useInterviewTemplate } from 'common/hooks/useInterviewTemplate'
import Constants from '../../common/utils/constants'
import { LifeThroughLegalLensComingSoonSection } from './components/LifeThroughLegalLensComingSoonSection'
import { useArticleTemplate } from 'common/hooks/useArticleTemplate'

const DiscoverLaw = () => {
  const [mostViewedSelected, setMostViewedSelected] = useState(false)
  const { results: interviews, loadInterviews } = useInterviewTemplate()

  const {
    results,
    sortOption,
    setSortOption,
    loadArticles,
    loadMostViewed,
    mostViewed,
  } = useArticleTemplate({ pageSize: 6 })

  useEffect(loadArticles, [loadArticles])
  useEffect(loadMostViewed, [loadMostViewed])
  useEffect(loadInterviews, [loadInterviews])

  return (
    <main id='discover-law'>
      <FeaturedArticle />

      <DiscoverLawFilterSection
        setSortOption={setSortOption}
        sortOption={sortOption}
        mostViewedSelected={mostViewedSelected}
        setMostViewedSelected={setMostViewedSelected}
      />

      <DiscoverLegalPerspective
        articles={mostViewedSelected ? mostViewed : results}
      />
      <DiscoverPodcast />

      <DiscoverMore />

      {/* Commented out until videos are ready. */}
      {/* <LifeThroughLegalLensSection /> */}
      {/* <div className='px-[10px] lg:px-[80px]'>
        <div className='md:p-[20px] lg:p-[25px]  rounded-lg !bg-[#EBEBFF] '>
          <h2  className="text-[#020251]  text-[18px] font-bold leading-[24px] tracking-[0.4px] mb-4">
         
          Our interviews
          </h2>
          <div className='h-[520px] overflow-auto'>
          {interviews.map((data, idx) => (
            <div className='mb-4' key={idx}>
              <InterviewList data={data}  />
            </div>
          ))}
          </div>
        
        </div>
      </div> */}
      <LifeThroughLegalLensComingSoonSection />

      <div className='flex text-center justify-center my-[100px]'>
        <div>
          <p className='text-[#101828] text-[18px] font-bold pb-4 pt-12 text-center'>
            Looking to contribute? Got something to share?
          </p>
          <Button
            className='btn-primary mt-4 '
            onClick={() => {
              window.location.href = `mailto:${Constants.supportEmail}`
            }}
          >
            Email us
          </Button>
        </div>
      </div>
    </main>
  )
}

export default DiscoverLaw
